import {observer} from "mobx-react";
import {useServices} from "../../../../../react-hooks/use-services.hook";
import {OptInHighlightContentBox} from "./boxes/opt-in-heighlight-content/opt-in-heighlight-content.box";
import {OptInDialogHeaderBox} from "./boxes/opt-in-dialog-header.box";
import {OptInHeaderRowContainerBox} from "./boxes/opt-in-header-row-container/opt-in-header-row-container.box";
import {OptInHighlightLabelBox} from "./boxes/opt-in-highlight-label/opt-in-highlight-label.box";
import {OptInHighlightTextBox} from "./boxes/opt-in-heighlight-text/opt-in-heighlight-text.box";
import {OptInOuterFrameBox} from "./boxes/opt-in-outer-frame/opt-in-outer-frame.box";


interface OptInDialogHeaderProps {
    isExpanded: boolean
}
export const OptInDialogHeaderComponent: React.FC<OptInDialogHeaderProps> = observer((props) => {
    const services = useServices();

    const renderIconJustInPortrait = () => {
        const JackpotIconIcon = services.theme.currentTheme.icons.blackjackIcon;
        const isLandscapeAndM = services.mediaQuery.landscape && services.mediaQuery.mAndBelow;
        if (isLandscapeAndM && props.isExpanded) {
            return null;
        }

        return <JackpotIconIcon size={4.2} style={{marginRight: "10px", color: services.theme.currentTheme.colors.brandPrimary}} />
    }

    return (
        <OptInOuterFrameBox>
            <OptInDialogHeaderBox>
                {renderIconJustInPortrait()}
                <OptInHeaderRowContainerBox>
                    <OptInHighlightLabelBox>{services.translation.translate('Winners Today')}</OptInHighlightLabelBox>
                    <OptInHighlightContentBox $isFirst>
                        <OptInHighlightTextBox>
                            {services.jackpotBet.jackpotsInfo.winnersCount}
                        </OptInHighlightTextBox>
                    </OptInHighlightContentBox>
                    <OptInHighlightLabelBox>{services.translation.translate('Wins Today')}</OptInHighlightLabelBox>
                    <OptInHighlightContentBox>
                        <OptInHighlightTextBox>
                            {services.currency.formatMoney(services.jackpotBet.jackpotsInfo.totalWinsToday)}
                        </OptInHighlightTextBox>
                    </OptInHighlightContentBox>
                </OptInHeaderRowContainerBox>
            </OptInDialogHeaderBox>
        </OptInOuterFrameBox>
    )
})